
import { Prop, Watch } from 'vue-property-decorator';
import { Options, Vue } from 'vue-class-component';
import * as OM from '@/Model';

@Options({})
export default class ChooseProcessToCopyModal extends Vue {

    @Prop() layerList: OM.LayerComposition[];
    @Prop() productionPhase: string;
    @Prop() selectedLayer: OM.LayerComposition;

    @Prop() allProductionProcesses: OM.ProductionProcessListVM[];
    @Prop() layerProductionProcesses: {[key: string]: OM.FabricProductionProcess[]};
    @Prop() countries: OM.TextIdentifier[];

    @Prop() saveCallback: (selectedLayersToCopyInto: string) => void;

    selectedLayersToCopyInto: string = "";

    created() {}

    get disabled() {
        return !this.selectedLayersToCopyInto;
    }

    rawMaterials(layerName: string) {
        var ris = [];
        for (let name in this.groupedbyLayer(layerName)) {
            for (let materialId in this.groupedbyLayer(layerName)[name]) {
                const materialData = this.groupedbyLayer(layerName)[name][materialId][0].rawMaterial;
                const productionCountry = this.groupedbyLayer(layerName)[name][materialId][0].productionCountry;
                if (!ris.some(material => material.identifier === materialData.identifier)) {
                    var obj = {
                        identifier: materialData.identifier,
                        rawMaterial: materialData,
                        productionCountry: productionCountry
                    }
                    ris.push(obj);
                }
            }
        }
        return ris;
    }

    groupedbyLayer(layerName: string) {
        if(this.layerProductionProcesses[layerName].length == 0)
            return [];

        let groupedByName = this.layerProductionProcesses[layerName]
        .filter( x => !x.rawMaterialIndipendent)
        .filter( x => x.productionPhase.text == this.productionPhase)
        // .filter( x => x.emissionCalculation == null)
        .reduce((acc, item) => {
            if (!acc[item.name]) {
                acc[item.name] = [];
            }
            acc[item.name].push(item);
            return acc;
        }, {});

        // Secondo passaggio: raggruppamento per "rawMaterial" all'interno di ogni gruppo "name"
        for (let name in groupedByName) {
            groupedByName[name] = groupedByName[name].reduce((acc, item) => {
                let key = item.rawMaterial.identifier;
                if (!acc[key]) {
                    acc[key] = [];
                }
                acc[key].push(item);
                return acc;
            }, {});
        }

        return groupedByName;
    }

    save() {
        this.saveCallback(this.selectedLayersToCopyInto);
    }
}
